interface FaqItem {
  question: string;
  answer: string;
}

const faqData: FaqItem[] = [
  {
    question: '51爆料是什么网站？',
    answer: '51爆料是一个聚合全网吃瓜爆料的资讯平台，实时追踪娱乐圈八卦、网红动态、社会热点事件等内容。我们覆盖微博、抖音、小红书等100+主流平台，每天更新200+条最新爆料，让吃瓜群众不错过任何一个热点。',
  },
  {
    question: '51爆料的爆料内容来源可靠吗？',
    answer: '我们的内容来源于全网公开平台的资讯聚合与整理，所有爆料信息均标注来源。对于未经证实的传闻，我们会明确标注「传闻」标签。我们建议用户理性吃瓜，不传播未经核实的信息。',
  },
  {
    question: '如何向51爆料投稿？',
    answer: '欢迎通过投稿邮箱 tougao@51baoliao.com 向我们发送爆料线索。请在邮件中附上相关截图、链接或详细描述，我们的编辑团队会在24小时内审核并回复。优质爆料将获得首页推荐展示。',
  },
  {
    question: '51爆料的内容更新频率是怎样的？',
    answer: '51爆料实行7×24小时实时更新机制，编辑团队全天候监控全网热点。热搜榜单每30分钟自动刷新，专题内容每日更新，确保用户随时都能看到最新最热的吃瓜资讯。',
  },
  {
    question: '51爆料是否收费？',
    answer: '51爆料完全免费！所有爆料内容、热搜榜单、专题报道均可免费浏览。我们致力于为吃瓜群众打造一个开放、及时的资讯聚合平台，不设置任何付费墙或会员门槛。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于51爆料吃瓜网，你可能想了解的一切
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-3 flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-accent-600 text-xs font-bold">Q</span>
                </span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}